<template>
  <CConfirm ref="refCConfirm" default-title="面对面确认收货" :footer="false">
    <div class="qr-cord-popop c:col-start-center">
      <p class="qr-cord-desc">向您的销售出示此二维码</p>
      <div class="qr-cord-wrapper">
        <img v-if="codeUrl" :src="codeUrl" alt="" />
      </div>
      <div v-if="brandInfo.qrExpiry?.enabled" class="qr-cord-timer">
        {{ seconds }}s 后刷新
      </div>
    </div>
  </CConfirm>
</template>

<script>
import { getQrCode } from "@/api";
import CConfirm from "@/components/common/CConfirm.vue";
import { mapState } from "vuex";

export default {
  components: { CConfirm },
  data() {
    return { orderId: "", codeUrl: "", seconds: 0, shown: false };
  },
  computed: {
    ...mapState(["brandInfo"]),
  },
  methods: {
    show(orderId) {
      if (orderId) {
        return new Promise((resolve, reject) => {
          this._resolve = resolve;
          this._reject = reject;
          this.orderId = orderId;
          this.code = "";
          this.update();
        });
      }
      return Promise.reject("orderId is required");
    },
    async update() {
      this.$toast.loading({
        message: "",
        forbidClick: true,
      });
      try {
        this.seconds = 0;
        if (this._timer) clearInterval(this._timer);
        const res = await getQrCode(this.orderId);
        // console.log("res", res);
        this.codeUrl = res;
        if (this.brandInfo.qrExpiry?.enabled) {
          this.seconds = this.brandInfo.qrExpiry.expiryTime;
          this._timer = setInterval(() => {
            if (this.seconds > 0) {
              this.seconds = this.seconds - 1;
            } else {
              this.update();
            }
          }, 1000);
        }

        if (!this.shown) {
          this.shown = true;
          this.$refs.refCConfirm?.show().catch(() => {
            this.shown = false;
            if (this._timer) clearInterval(this._timer);
            if (this._resolve) {
              this._resolve();
              this._resolve = null;
              this._reject = null;
            }
          });
        }
        this.$toast.clear();
      } catch (error) {
        this.hide();
        if (error?.message) this.$toast(error.message);
        else this.$toast.clear();
        this.codeUrl = "";
        this.seconds = 0;
        if (this._reject) {
          this._reject();
          this._resolve = null;
          this._reject = null;
        }
      }
    },
    hide() {
      if (this.shown) {
        this.$refs.refCConfirm?.hide();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.qr-cord-popop {
  padding-bottom: 24/20rem;
}

.qr-cord-desc {
  margin-bottom: 6/20rem;

  line-height: 17/20rem;
  font-weight: 400;
  font-size: 12/20rem;
  letter-spacing: 0;
  text-align: center;

  color: #7d7d7d;
}
.qr-cord-wrapper {
  margin-top: 2/20rem;

  width: 172/20rem;
  height: 172/20rem;

  img {
    width: 100%;
    height: 100%;
  }
}

.qr-cord-timer {
  line-height: 17/20rem;
  font-weight: 400;
  font-size: 12/20rem;
  letter-spacing: 0;
  text-align: center;
  color: #333;
}
</style>
